import styled from 'styled-components';
import tw, { classnames, position, fontSize, borderRadius, textColor, boxShadow, padding, backgroundColor } from 'tailwindcss-classnames'

const classBase = classnames(position('relative'), fontSize('text-sm'), borderRadius('rounded-sm'), textColor('text-white'), boxShadow('shadow-md'), padding('py-1', 'px-3'));

const PrimaryClass = classnames(backgroundColor('bg-gpas-700', 'hover:bg-gpas-900'));
const SecondaryClass = classnames(textColor('text-purple-500', 'hover:text-purple-700'), backgroundColor('bg-white'));
const DangerousClass = classnames(backgroundColor('bg-red-500', 'hover:bg-red-700'));
const SuccessClass = classnames(backgroundColor('bg-green-500', 'hover:bg-green-700'));

export const StyledButton = (color: 'primary' | 'secondary' | 'dangerous' |'success', attrs: any) => {
    const ButtonClass = color ==='primary' ? PrimaryClass : color === 'dangerous' ? DangerousClass : color === 'success' ? SuccessClass : SecondaryClass;
    return styled.button.attrs({
        className: classnames(classBase, ButtonClass, attrs.size === 'sm' ? fontSize('text-sm') : fontSize('text-base')),
        ...attrs
    })``;
};
